import makeRequest from ".";

export function addSubscribe(requestBody) {
  return makeRequest({
    method: "POST",
    uri: `/plan-subscribe`,
    body: JSON.stringify(requestBody),
  });
}
